var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestaltPrinciple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 41,
    viewBox: "0 0 58 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.764648,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.7646C18 9.71895 26.9543 0.764648 38 0.764648C49.0457 0.764648 58 9.71895 58 20.7646C58 31.8103 49.0457 40.7646 38 40.7646C26.9543 40.7646 18 31.8103 18 20.7646Z",
    fill: "white",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaltPrinciple);
export default __webpack_public_path__ + "static/media/gestalt-principle.9cb5043f35429486064bff34286f7aea.svg";
export { ForwardRef as ReactComponent };